/**
 *
 * @class sgvizler.SPARQL_RESULT
 * @memberof sgvizler
 */
export var SPARQL_RESULT;
(function (SPARQL_RESULT) {
    SPARQL_RESULT[SPARQL_RESULT["xml"] = 0] = "xml";
    SPARQL_RESULT[SPARQL_RESULT["json"] = 1] = "json";
    SPARQL_RESULT[SPARQL_RESULT["jsonp"] = 2] = "jsonp";
})(SPARQL_RESULT || (SPARQL_RESULT = {}));
/**
 *
 * @class sgvizler.SparqlTools
 * @memberof gvizler
 */
export class SparqlTools {
    static getOutputLabel(id) {
        let str = '';
        switch (id) {
            case SPARQL_RESULT.xml:
                str = 'xml';
                break;
            case SPARQL_RESULT.json:
                str = 'json';
                break;
            case SPARQL_RESULT.jsonp:
                str = 'jsonp';
                break;
        }
        return str;
    }
    static getXMLHttpRequestResponseType(id) {
        let type = '';
        switch (id) {
            case SPARQL_RESULT.xml:
                type = ''; // 	DOMString (this is the default value for xhr)
                break;
            case SPARQL_RESULT.json:
            case SPARQL_RESULT.jsonp:
                type = 'json';
                break;
        }
        return type;
    }
    static getHeaderAccept(id) {
        let str = '';
        switch (id) {
            case SPARQL_RESULT.xml:
                str = 'application/sparql-results+xml';
                break;
            case SPARQL_RESULT.json:
            case SPARQL_RESULT.jsonp:
                str = 'application/sparql-results+json';
                break;
        }
        return str;
    }
    static convertString(label) {
        let result = SPARQL_RESULT.json;
        switch (label) {
            case 'xml':
                result = SPARQL_RESULT.xml;
                break;
            case 'json':
                result = SPARQL_RESULT.json;
                break;
            case 'jsonp':
                result = SPARQL_RESULT.jsonp;
                break;
        }
        return result;
    }
}
//# sourceMappingURL=data:application/json;base64,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